module.exports = require('./lib/noGetters');



//////////////////
// WEBPACK FOOTER
// ./~/react-lazy-cache/noGetters.js
// module id = 1935
// module chunks = 0